module.exports = __webpack_public_path__ + "static/img/3-07.0d68e96.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/3/3-07.png
// module id = 234
// module chunks = 0